/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles/style_helpers';


// ********* HELPERS ********* //
const pagePropertiesThinStyles = {
	width: pxToEm(150),
	'& .picker': {
		'& .sketch-picker': {
			width: `${pxToEm(130)} !important`,
		}
	}
};
const pagePropertiesThinnestStyles = {
	width: '100%',
	'& .picker': {
		'& .sketch-picker': {
			width: `${pxToEm(200)} !important`,
		}
	}
};


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE PROPERTIES: STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	pageproperties: {
		position: 'relative',
		textAlign: 'left',
		width: pxToEm(200),
		'& .background': {
			marginBottom: pxToEm(8)
		},
		'& .selectedContentType': {
			 marginTop: pxToEm(16),
			 marginBottom: pxToEm(18),
		},
		'& .picker': {
			position: 'absolute',
			top: 0,
			'& .sketch-picker': {
				width: `${pxToEm(180)} !important`,
				borderRadius: '0 !important'
			}
		},
		'& .textfield':{
			fontFamily: `${theme.typography.font} !important`,
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: {
		pageproperties: {
			extend: pagePropertiesThinnestStyles
		}
	},
	[mediaQuery.customizeRailThin]: {
		pageproperties: {
			'&.rail': { extend: pagePropertiesThinStyles }
		}
	},
	[mediaQuery.customizeInContentThin]: {
		pageproperties: {
			'&.incontent': { extend: pagePropertiesThinStyles }
		}
	}
});